import React from "react";
// import Slider from "react-slick";
import { Slide } from "react-slideshow-image";
import Separator from "../../common/separator";
import { ProjectData } from "../../data/projects";
import ProjectCard from "./project-card";
import "./projects.css";
import AwesomeSlider from "react-awesome-slider";
import Slider from "infinite-react-carousel";

import "react-awesome-slider/dist/styles.css";
function Projects() {
  const settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    className: "slide_box",
    dots: true,
    virtualList: true,
    duration: 20,
    arrows: true,
  };
  const data = ProjectData;
  return (
    // <div className="containerSlide">
    //   <Separator />
    //   <label className="section-title">Projects</label>
    //   <Slide {...proprietes}>
    //     {data.map((project) => {
    //       return <ProjectCard project={project} />;
    //     })}
    //   </Slide>
    // </div>
    <div className="containerSlide">
      <Separator />
      <label className="section-title">Projects</label>
      <Slider {...settings}>
        {data.map((project) => {
          return (
            <>
              <ProjectCard project={project} />
            </>
          );
        })}
      </Slider>
    </div>
  );
}

export default Projects;
